import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/empresas/zonas-de-modulos/';

/**
 * GET Zonas de Modulos
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getZonasDeModulos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Zona de Modulo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getZonaDeModulo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Zona de Modulo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postZonaDeModulo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Zona de Modulo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchZonaDeModulo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Zona de Modulo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteZonaDeModulo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
